import { Group, Box, rem } from '@mantine/core';
import { useState } from 'react';
import { RxCaretDown } from 'react-icons/rx';
import cn from 'clsx';
import { ErrorIcon } from 'src/assets';

const errorsMapping = [
  ['User rejected the request', 'User rejected the request. Please try again.'],
  [
    'Execution reverted for an unknown reason',
    'Transaction failed due to insufficient gas.',
  ],
];

export function ErrorDisplay({ children }: { children: React.ReactNode }) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!children) return null;

  let content = String(children);
  let isReplaced = false;

  for (const [error, replacement] of errorsMapping) {
    if (content.toLowerCase().includes(error.toLowerCase())) {
      content = replacement;
      isReplaced = true;
      break;
    }
  }

  return (
    <Group
      gap={16}
      w="100%"
      justify="space-between"
      wrap="nowrap"
      px={16}
      py={12}
      className="rounded-[16px] border border-solid border-[#EA543C] bg-[rgba(234,84,60,0.10)]"
    >
      <Group gap={16} className="grow flex-nowrap min-w-0">
        <ErrorIcon className="w-6 h-6 shrink-0" />
        <Box
          c="#EA543C"
          style={{
            overflow: 'hidden',
            flexGrow: 1,
            maxHeight: isReplaced || isExpanded ? undefined : rem(90),
            ...(isReplaced ? {} : { hyphens: 'auto' }),
          }}
        >
          {content}
        </Box>
      </Group>
      {!isReplaced && (
        <RxCaretDown
          onClick={() => setIsExpanded(!isExpanded)}
          size={32}
          color="#EA543C"
          className={cn(
            'cursor-pointer transition-transform shrink-0',
            isExpanded && 'rotate-180'
          )}
        />
      )}
    </Group>
  );
}
